<template>
  <div>
    <div class="fixed-part">
      <page-header @mounted="useFixedPart"></page-header>
    </div>

    <b-container fluid class="outer" >
      <year-calendar
              v-model="year"
              :activeDates.sync ="holidayDates"
              @toggleDate="toggleDate"
              lang="en"
              :showYearSelector="showYearSelector"
      ></year-calendar>

    </b-container>

    <b-container fluid class="outer"><server-processing :serverIsBusy="dataLoading"/></b-container>

  </div>

</template>

<script>
import fixedHeader from '../_mixins/fixed-header.js';
import axios from '../_helpers/axios';
import { apiUrl } from 'config';

export default {
  components: {
    'page-header': () => import('@/components/Header.vue'),
    'year-calendar': () => import('vue-material-year-calendar'),
  },
  mixins: [fixedHeader],
  data: () => ({
    year: null,
    holidayDates: [],
    showYearSelector: true,
    fixedPart: null,
    fixedPartHeight: 0,
  }),
  mounted() {
    this.$store.dispatch('campaigns/getHolidays');
    this.$nextTick(()=>{
      this.year = new Date().getFullYear();
    });
  },
  methods: {
    toggleDate (dateInfo) {
      axios.post(`${apiUrl}/api/campaigns/setHoliday`, {addDay:dateInfo.selected?dateInfo.date:null,removeDay:dateInfo.selected?null:dateInfo.date})
        .then(() => {
          this.$store.commit('campaigns/holidayChanged',Object.assign(dateInfo,{date:new Date(dateInfo.date)}));
        });
    },

  },
  computed: {
    dataLoading() {
      return this.$store.state.campaigns.serverProcessing || false;
    },
    user() {
      return this.$store.state.authentication.user;
    },
    holidays() {
      let allItems = this.$store.state.campaigns.holidays || [];
      allItems = Array.isArray(allItems) ? allItems : [];
      allItems = allItems.map(e=>this.$mm(e).format('YYYY-MM-DD'));
      return allItems;
    },
  },
  watch: {
    holidays(newVal) {
      this.holidayDates = newVal;
    }
  }
};
</script>

<style scoped lang="scss">
@import '../assets/_scss/_component-base';

</style>
